import { ComparisonBlock } from "@foodpilot/foods";
import { Box, Stack, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { ScoreValue } from "src/api/client-api/post/scoreSchema";
import { ScoreService } from "src/context/EntityBasedScore/ScoreService";
import { useScoreDetailContext } from "src/context/ScoreDetail/useScoreDetailContext";

type PrevScoreLayoutProps = {
    total: ScoreValue;
    prevScore: ScoreValue;
    refScore?: ScoreValue;
    children: JSX.Element;
};
export const PrevScoreLayout = (props: PrevScoreLayoutProps) => {
    const {
        scoreList: { lastSelected },
        prevCampaign,
    } = useScoreDetailContext();
    const { children } = props;
    const theme = useTheme();
    const { t } = useTranslation();

    const doesTotalExist = props.total !== null;
    const doesPrevExist = props.prevScore !== null;
    const doesRefScoreExist = props.refScore !== undefined && props.refScore !== null;

    if (doesTotalExist === false) {
        return children;
    }
    return (
        <Stack flexDirection="row" gap={theme.spacing(4)}>
            {(doesPrevExist || doesRefScoreExist) && (
                <Stack
                    sx={{
                        width: "170px",
                        minWidth: "170px",
                        "& .comparison-block-wrapper": {
                            width: "100%",
                        },
                    }}
                    direction="column"
                    gap={theme.spacing(3)}
                >
                    {doesPrevExist && (
                        <ComparisonBlock
                            currentValue={props.total ?? 0}
                            comparedTo={{
                                value: ScoreService.normalizeScore(props.prevScore, 2).value ?? 0,
                                unit: lastSelected.unit,
                                label: prevCampaign,
                            }}
                            improvement="decrease"
                            layout={{
                                direction: "vertical",
                                size: "L",
                            }}
                        />
                    )}
                    {doesRefScoreExist && (
                        <ComparisonBlock
                            currentValue={props.total ?? 0}
                            comparedTo={{
                                value: ScoreService.normalizeScore(props.refScore, 2).value ?? 0,
                                unit: lastSelected.unit,
                                label: t("score_reference.the_reference"),
                            }}
                            improvement="decrease"
                            layout={{
                                direction: "vertical",
                                size: "L",
                            }}
                        />
                    )}
                </Stack>
            )}
            <Box
                display="flex"
                flexDirection="column"
                sx={{
                    width: "100%",
                    border: `1px solid ${theme.palette.grey[500]}`,
                    borderRadius: "12px",
                    padding: theme.spacing(2),
                    justifyContent: "center",
                }}
            >
                {children}
            </Box>
        </Stack>
    );
};
